import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91dff34c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "chat_history" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageWrapper = _resolveComponent("MessageWrapper")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg) => {
      return (_openBlock(), _createElementBlock("div", {
        key: msg.id,
        ref: "messages"
      }, [
        _createVNode(_component_MessageWrapper, {
          msg: msg.text,
          sent: msg.sender === 'me',
          image: msg.image
        }, null, 8, ["msg", "sent", "image"])
      ], 512))
    }), 128)),
    (_ctx.writing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Loading)
        ]))
      : _createCommentVNode("", true)
  ]))
}